import type { SVGProps } from 'react';

import { unitMapping, type Unit } from '#src/lib/style.ts';

type SVGRProps = {
  title?: string;
  titleId?: string;
  size?: Unit;
};

export const SetColors = ({
  title,
  titleId,
  size = 2,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 64 64"
      aria-labelledby={titleId}
      style={{ height: unitMapping[size] }}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="m30.9373 9.62731-3.7095 5.81859-5.3671 2.0699-1.6213 2.7101-2.021-2.9058 1.0454-2.889-1.6828-2.1692s3.012-2.43473 6.5803-3.40472l6.7774.77013zm-16.652 15.18999 2.288.2348 1.0077-1.9525-4.0253-3.388 1.5179-2.179.2627-3.648c-7.99749 7.8382-7.7459 16.9693-7.7459 16.9693l5.6942-4.5508 1.0007-1.4844zm-6.52159 11.6762c2.42499 11.6637 11.07099 16.6353 11.07099 16.6353l5.0387-8.2394-6.1316-4.8415-9.97669-3.5544zm42.72019-20.7052-2.9869.7114-2.9575-2.07-5.683.7031-3.0777 3.4369.5256 1.1419 1.9959.5213-.7604 1.2272-.7631-.4682-1.8422 2.5284h-1.3417l-.5339 2.1175-2.5326.5087-.1314 1.9526 1.6702.7575 2.0127-.9141 1.9092-2.2642 2.0252.5465 1.3153 1.1712.9672-.4416 2.0965 1.536 1.5137-.1565 2.9994 1.093v1.6786l-3.9107-.2516-2.903.369-2.9393-1.9638-5.1896.1678-3.9317 4.6081.2152 4.6082 3.3545 2.0308 5.3866.2348 1.6815 5.8577v4.7647l1.8337 3.5921 2.773-1.1322 2.5494-4.8807 1.434-1.4843.9379-3.8269 3.2076-4.295-.1621-.5465-2.1874-.39-3.9344-5.6229 1.1433-.8721 3.6954 5.1952 1.8645-.1845 2.0742-2.1091-.1789-1.1713-3.6843-1.7457-.1565-1.6003 6.8332 2.5354s.9519-9.0347-6.2294-17.1999zm-18.4606 6.3748 1.3613 1.0147.3229-.9266-.2139-.7142-1.1377-1.8254-1.8267 2.1384zm30.5128 9.8369c0 16.8644-13.6708 30.5352-30.5352 30.5352s-30.53654-13.6708-30.53654-30.5352 13.67074-30.53516 30.53514-30.53516 30.5352 13.67076 30.5352 30.53516zm-3.1728 0c0-15.1131-12.2507-27.36382-27.3638-27.36382s-27.3638 12.25212-27.3638 27.36382 12.2507 27.3638 27.3638 27.3638 27.3638-12.2507 27.3638-27.3638z"
        fill="currentColor"
      />
    </svg>
  );
};
